<template>
<Dialog :header="header" 
v-model:visible="$store.state.evaluation.show_null_modal" 
:breakpoints="{'960px': '75vw', '640px': '100vw'}" :style="{width: '50vw'}"
:modal="true"
>





<template v-if="$store.state.evaluation.nullreasons.length">
  <template v-if="items_readonly">
    <SelectOption v-for="item in $store.state.evaluation.nullreasons" :item="item" :key="item.id"  :selected="selected_reason" @optionSelected="reasonSelected" :readonly="true"></SelectOption>
  </template>
  <template v-if="!items_readonly">
    <SelectOption v-for="item in $store.state.evaluation.nullreasons" :item="item" :key="item.id"  :selected="selected_reason" @optionSelected="reasonSelected"></SelectOption>
  </template>
  
</template>



<!--
<Textarea  v-model="text" class="w-full p-inputtext-sm" :class="{'p-invalid':has_error }" @input="typing"  rows="8" />
<small  class="p-error pt-2" v-if="has_error"> {{$store.state.languages.lang_phrases.lutfen_bu_alani_doldurun}}</small>

-->




<template #footer>
<Button :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="close" class=" p-button-danger p-button-outlined  p-button-sm" :loading="$store.state.ui.submitting"/>
<template v-if="!items_readonly">
<Button :label="$store.state.languages.lang_phrases.kaydet" icon="pi pi-check" @click="submit"  class=" p-button-primary p-button-outlined  p-button-sm"  :loading="submitting"/>
</template>
</template>
</Dialog>	
</template>

<script>
import SelectOption from "./SelectOption"
export default {

  name: 'NullReasonModal',
  components:{SelectOption},
  data () {
    return {
    	text:"",
    	has_error:false,
    	submitting:false,
      selected_reason:null,
    }
  },
  computed:{
    header()
    {
      if(this.$store.state.evaluation.active_inputfield)
      {
        let active_inputfield = this.$store.state.evaluation.active_inputfield
        if(active_inputfield.read_only_state)
        {
          return this.$store.state.languages.lang_phrases.bos_birakma_nedeni
        }
        else
        {
          return this.$store.state.languages.lang_phrases.lutfen_bu_alani_bos_birakma_nedeninizi_bildirin
        }
      }
      else
      {
        return this.$store.state.languages.lang_phrases.lutfen_bu_alani_bos_birakma_nedeninizi_bildirin
      }
    },
    items_readonly()
    {
      if(this.$store.state.evaluation.active_inputfield)
      {
        let active_inputfield = this.$store.state.evaluation.active_inputfield
        if(active_inputfield.read_only_state)
        {
          return true
        }
        else
        {
          return false
        }
      }
      else
      {
        return false
      }
    },
  	activeinputfieldnullreason()
  	{
  		
  		if(this.$store.state.evaluation.active_inputfield && this.$store.state.evaluation.active_inputfield.null_reason)
  		{
  			console.log("activeinputfieldnullreason")
  			return this.$store.state.evaluation.active_inputfield.null_reason
  		}
  		else
  		{
  			return ""
  		}
  		
  	},
    show_null_modal()
    {
      return this.$store.state.evaluation.show_null_modal
    }
  },
  watch:{
  	activeinputfieldnullreason(newval,oldval)
  	{
  		console.log("watch")
  		console.log(newval)
  		this.inputdata = newval
  	},
    show_null_modal(newval,oldval)
    {
      if(newval)
      {
        if(this.$store.state.evaluation.active_inputfield.submissions.length)
        {
          this.selected_reason = this.$store.state.evaluation.active_inputfield.submissions[0].null_reason
        }
        else
        {
          this.selected_reason = null
        }
      }
    }
  },
  methods:{
  	close()
  	{
  		this.$store.dispatch('evaluation/setNullModal',false) 
  	},
  	typing()
  	{
  		this.has_error = false
  	},
    reasonSelected(event)
    {

      console.log(event)
      this.selected_reason = event
    },
  	submit()
  	{
  		if(!this.selected_reason)
  		{
  			this.has_error = true
  			return false
  		}
  		let formdata = new FormData()
  		formdata.append("text",this.selected_reason)
  		formdata.append("flowsupplier_id",this.$store.state.evaluation.evaluation.uuid)
  		console.log(this.text)
  		this.submitting = true
  		//return false
      this.$store.dispatch('evaluation/setInputfieldsUpdating',true)
  		this.generalSubmission(formdata,"audit/submit_inputfield_null_reason/"+this.$store.state.evaluation.active_inputfield.id,this.afterSubmit)
  	},
  	afterSubmit(response)
  	{
      console.log("afterSubmit nullreason")
     	this.$store.dispatch('evaluation/setNullModal',false) 
     	this.submitting = false
     	this.text = ""
      this.aftersubmitInputData(response)
  	},
  }
};
</script>

<style lang="css" scoped>
</style>